// extracted by mini-css-extract-plugin
export default {"dialog":"QspwHO2EBwiDwIp_","body":"vGvKegtMw88PlsOB","header":"RivUE3uGoM6COF_z","title":"OF9pUlsOvzEZGWKt","subTitle":"hSJsazDc9wOcsdKe"};